import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationDefaultPortionCreateRequest, ConfigurationDefaultPortionPatchInBatchRequest, ConfigurationDefaultPortionResponse } from '@/modules/configurationModule/detail/automation/portions/services/configuration-portions.dto'

class PortionsConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationDefaultPortionResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationDefaultPortionResponse>>(`/configuration/laboratories/${laboratoryId}/defaultPortion`, filterModel, { params })
        return response.data
    }

    async getDefaultPortionById(laboratoryId: number, defaultPortionId: number): Promise<ConfigurationDefaultPortionResponse> {
        const response = await axios.get<ConfigurationDefaultPortionResponse>(`/configuration/laboratories/${laboratoryId}/defaultPortion/${defaultPortionId}`)
        return response.data
    }

    async createDefaultPortion(laboratoryId: number, request: ConfigurationDefaultPortionCreateRequest): Promise<ConfigurationDefaultPortionResponse> {
        const response = await axios.post<ConfigurationDefaultPortionResponse>(`/configuration/laboratories/${laboratoryId}/defaultPortion`, request)
        return response.data
    }

    async deleteDefaultPortion(laboratoryId: number, defaultPortionsIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/defaultPortion/batch`, { data: defaultPortionsIds })
        return response.data
    }

    async patchDefaultPortion(laboratoryId: number, requests: ConfigurationDefaultPortionPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/defaultPortion/batch`, requests)
        return response.data
    }
}

export const portionsConfigurationServices = new PortionsConfigurationServices()
